<template>
  <div class="msgwrp">
    <div class="textmsg fileMsg">
      <a target="_blank" :href="data.filePath">
        <img src="../../assets/file.png" width="24" height="24" />
        {{ data.Text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
<style>
.fileMsg a {
  color: inherit;
  text-decoration: underline;
  word-break: break-all;
}
.fileMsg img {
  vertical-align: middle;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatMessageFile.vue